import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MessageRelation } from '../models/message-relation';
import { Document } from '../models';
import { DateTimeService } from 'src/app/shared/datetime/datetime.service';
import { MessageRelationType } from '../models/message-relation-types';

import { TrackingMessageRelationsItemComponent } from '../tracking-message-relations-item/tracking-message-relations-item.component';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';

@Component({
    selector: 'app-tracking-message-relations-row',
    templateUrl: './tracking-message-relations-row.component.html',
    styleUrls: ['./tracking-message-relations-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TrackingMessageRelationsItemComponent, SvgIconComponent]
})
export class TrackingMessageRelationsRowComponent {
  @Input() messageRelation: MessageRelation = null;
  @Input() document: Document = null;
  @Input() messageRelationTypes: MessageRelationType[] = [];
  @Output() openDocument = new EventEmitter<number>();
  @Output() openInterchange = new EventEmitter<number>();

  constructor(
    public dateTimeService: DateTimeService
  ) {
  }

  get relation(): MessageRelationType {
    return this.messageRelationTypes.find(e => e.Id === this.messageRelation.MessageRelationTypeId);
  }

  openDocument2(docId: number) {
    this.openDocument.emit(docId);
  }

  openInterchange2(intId: number) {
    this.openInterchange.emit(intId);
  }
}
